import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  DocumentsDocument,
  RemoveFromTrashBinDocument,
  RemoveFromTrashBinMutation,
  RemoveFromTrashBinMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useRemoveFromTrashBinDocument = ({ fromDataTable = false }: { fromDataTable?: boolean }) => {
  const [removeDocumentsFromTrashBin, { loading }] = useMutation(RemoveFromTrashBinDocument, {
    extractorFn: (data: RemoveFromTrashBinMutation) =>
      data.documentsMutations.removeFromTrashBinDocumentsDocument,
  })

  return {
    loading,
    removeDocumentsFromTrashBin(variables: RemoveFromTrashBinMutationVariables) {
      return removeDocumentsFromTrashBin({
        variables,
        awaitRefetchQueries: true,
        ...(fromDataTable
          ? {
              refetchQueries: [DocumentsDataTableDocument],
            }
          : {
              refetchQueries: [DocumentsDocument],
            }),
      })
    },
  }
}

export default useRemoveFromTrashBinDocument
